export default __webpack_public_path__ + "images/models/b9c370add099e9f21dbc045c612e7444.usdz";